export default class Carousel{
	constructor(){
		const carousels = document.querySelectorAll(".carousel");
		carousels.forEach(carousel=>{
			this.buildCarousel(carousel)
		});
	}
	
	buildCarousel(carousel){
		// carousel.setAttribute("data-position", 0);

		const container = carousel.querySelector(".carousel__container");
		const blocks = carousel.querySelectorAll(".carousel__item");
		const pager = carousel.querySelector(".carousel__pager");
		const pageDomString = '<div class="carousel__pager__page"><svg height="22" width="22"><circle stroke="#000" stroke-width="2" fill="transparent" r="10" cx="11" cy="11" /></svg></div>';

		let pageMax = blocks.length;
		let inViewItems = 1;
		if(carousel.classList.contains("wedding-blog__carousel")){
			inViewItems = window.currentContext == "pc" ? 2 : 1;
		}
		if( pageMax <= inViewItems ){
			//isActive = false;
			carousel.classList.add("inactive");
			return;
		}

		for(let i=0; i<blocks.length; i++){
			pager.innerHTML += pageDomString;
			pager.querySelectorAll(".carousel__pager__page")[i].setAttribute("data-num", i);
		}

		let position = 0;
		let nextPosition = 0;
		let now = Date.now();
		let then = Date.now();
		let elapsed = 0;
		let timerActive = true;
		let request = null;
		let isMoving = false;
		let moveWaitTimer = null;
		const delay = 5000;
		let pages = pager.querySelectorAll(".carousel__pager__page");
		let isActive = true;
		let delayTimer = null;
		let isStarted = false;

		const cloneA = document.createElement("div");
		const cloneB = document.createElement("div");
		cloneA.classList.add("cloneA"); cloneA.classList.add("group");
		cloneB.classList.add("cloneB"); cloneB.classList.add("group");
		for(let i=0; i<inViewItems; i++){
			if(blocks.item(i)){
				cloneA.appendChild(blocks.item(i).cloneNode(true));
			}
			if(blocks.item(blocks.length-(inViewItems-i))){
				cloneB.appendChild(blocks.item(blocks.length-(inViewItems-i)).cloneNode(true));
			}
		}
		container.appendChild(cloneA);
		container.appendChild(cloneB);

		function move(target=true, isDragged=false){
			isMoving = true;
			if(target===true){
				nextPosition = (position+1 >= pageMax) ? 0 : position+1;
				carousel.setAttribute("data-position", position+1);
			}else if(target===false){
				nextPosition = (position-1 < 0) ? pageMax-1 : position-1;
				carousel.setAttribute("data-position", position-1);
			}else{
				nextPosition = target;
				carousel.setAttribute("data-position",nextPosition);
			}
			pages.forEach(page=>{
				page.classList.remove("active");
				page.classList.remove("pause");
			});
			pages.item(nextPosition).classList.add("active");
			container.classList.add("moving");
			if(isDragged) container.classList.add("moveByDrag");
			position = nextPosition;
			elapsed = 0;
			now = Date.now();
			then = Date.now();

			moveWaitTimer = setTimeout(()=>{
				moveComplete();
			}, 750);
			// countRestart();
		}
		function moveComplete(){
			clearTimeout(moveWaitTimer);
			container.classList.remove("moving");
			container.classList.remove("moveByDrag");
			carousel.setAttribute("data-position", position);
			isMoving = false;
		}
		function countdown(){
			if(!isActive) return;
			now = Date.now();
			elapsed += (now - then);
			if(elapsed > delay){
				elapsed = 0;
				if(isMoving) moveComplete();
				requestAnimationFrame(()=>{
					move();
				});
			}
			then = Date.now();
			if(timerActive)	request = requestAnimationFrame(countdown);
		}
		function countPause(){
			cancelAnimationFrame(request);
			timerActive = false;
			if(pageMax <= 1) return;
			pages.item(position).classList.add("pause");
		}
		function countResume(){
			cancelAnimationFrame(request);
			if(pageMax <= 1) return;
			pages.item(position).classList.remove("pause");
			timerActive = true;
			now = Date.now();
			then = Date.now();
			countdown();
		}
		function countRestart(){
			if(!isActive) return;
			countResume();
			/*
			if(delayTimer) clearTimeout(delayTimer);
			delayTimer = setTimeout(move, delay);
			*/
		}

		function carouselResizeHandler(){
			const ctx = (window.innerWidth >= 767) ? "pc" : "sp";
			if(ctx != window.currentContext){
				window.currentContext = ctx;
				modeToggle();
			}
		}
		function modeToggle(){
			position = 0;
			if(moveWaitTimer) clearTimeout(moveWaitTimer);
			carousel.setAttribute("data-position", 0);
			container.classList.remove("moving");
			container.classList.remove("moveByDrag");
			isActive = true;
			pages.forEach(page=>{
				page.classList.remove("active");
				page.classList.remove("pause");
			});
			if( pageMax <= inViewItems ){
				isActive = false;
			}
			if(isActive){
				carousel.classList.remove("inactive");
				countRestart();
				pages.item(position).classList.add("active");
				isMoving = false;
			}else{
				carousel.classList.add("inactive");
				countPause();
			}
		}

		if(isTouch){
			let dragStartX = 0;
			let dragStartY = 0;
			let dragLastX = 0;
			let dragLastY = 0;
			let dragActive = null;

			carousel.addEventListener("touchstart", (e)=>{
				if(e.changedTouches){
					dragStart(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
				}else{
					dragStart(e.pageX,e.pageY,e);
				}
			}, false);
			carousel.addEventListener("touchmove", (e)=>{
				if(e.changedTouches){
					dragMove(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
				}else{
					dragMove(e.pageX,e.pageY),e;
				}
				if(dragActive){
					return false;
				}
			}, false);
			carousel.addEventListener("touchleave", ()=>{
				dragLeave();
			}, false);
			carousel.addEventListener("touchend", (e)=>{
				dragEnd();
			}, false);

			function dragStart(x,y,e){
				dragStartX = x;
				dragStartY = y;
				dragLastX = x;
				dragLastY = y;
				dragActive = null;
				container.classList.add("dragging");
				moveComplete();
				let basePosition;
				if(window.currentContext=="pc"){
					basePosition = (-50*position)+"%"
				}else{
					basePosition = (-100*position)+"%"
				}
				container.style.transform = "translate(calc("+basePosition+"),0%)";
				countPause();
			}
			function dragMove(x,y,e){
				if(dragActive === null){
					if(Math.abs(dragStartX-x) > Math.abs(dragStartY-y)){
						dragActive = true;
					}else{
						dragActive = false;
					}
				}
				if(dragActive !== true) return false;
				let basePosition;
				if(window.currentContext=="pc"){
					basePosition = (-50*position)+"%"
				}else{
					basePosition = (-100*position)+"%"
				}
				container.style.transform = "translate(calc("+basePosition+" + "+((x-dragStartX)/2)+"px),0%)";
				dragLastX = x;
				dragLastY = y;
				e.preventDefault();
			}
			function dragLeave(){
				resetDragging();
			}
			function dragEnd(){
				resetDragging();
				if(Math.abs(dragStartX - dragLastX) > 30){
					if(dragStartX > dragLastX){
						move(true, true);
					}else{
						move(false, true);
					}
				}
			}
			function resetDragging(){
				container.classList.remove("dragging");
				container.removeAttribute("style");
				countResume();
			}
		}

		pages.forEach(page=>{
			page.addEventListener("click", ()=>{
				if(isMoving) return;
				move(page.getAttribute("data-num")*1);
			}, false);
		});
		blocks.forEach(item=>{
			item.addEventListener("mouseenter", countPause, false);
			item.addEventListener("mouseleave", countResume, false);
		});

		window.addEventListener("resize", carouselResizeHandler, false);
		carouselResizeHandler();

		function start(){
			if(isStarted) return;
			if(!isActive) return;
			const bound = carousel.getBoundingClientRect();
			if(bound.top < window.innerHeight){
				pages.item(position).classList.add("active");
				countRestart();
				isStarted = true;
			}
		}
		window.addEventListener("scroll", start, false);
		start();
	}
}